import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioNovaSenha } from 'src/app/core/models/usuario-nova-senha.model';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { WeblabService } from 'src/app/core/services/weblab.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-atualizar-senha',
  templateUrl: './atualizar-senha.component.html',
  styleUrls: ['./atualizar-senha.component.scss']
})
export class AtualizarSenhaComponent implements OnInit {
  img: string = '';
  imagemLogoBase64: any;
  usuario: UsuarioNovaSenha;
  loading: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private service: WeblabService,
    private router: Router) {

  }

  ngOnInit(): void {
    this.usuario =
    {
      email: this.authenticationService.obterEmailUsuarioLogado ?? '',
      senhaNova: '',
      senhaNovaConfirma: ''
    };

    this.imagemLogoBase64 = this.authenticationService.obterEmpresa.logo_laboratorio;
  }

  atualizarSenha() {
    this.loading = true;

    this.service.alterarSenha(this.usuario).subscribe((res) => {
      this.loading = false;
      // this.router.navigate(['']);
      this.router.navigate([environment.router.dashboard]);
    },
      (error) => this.loading = false)
  }

}
